import React, { useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselInicio } from '../../json/carousel';
import Mosaico from '../Mosaico/Mosaico';
import Face from '../Face/Face';
import NuestrosTramites from '../NuestrosTramites/NuestrosTramites';
import Convocatoriapdf from '../components/Concocatorias/Convocatoriapdf.js';


const Inicio = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='secretaria_logo' >
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Gobierno.svg")` }}>

              </div>
            </div>
          </div>



<div className='secretaria_name'>
            <h1>SECRETARÍA DE GOBIERNO</h1>
          </div>
         <div className='btn_organigrama'>
{/* <Link to="/Organigrama" className="btn btn-primary">Directorio</Link> */}

              </div> 

<UltimasNoticias></UltimasNoticias>







          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>La Secretaría de Gobierno del Estado de Hidalgo tiene dentro de sus
facultades coordinar y supervisar diversas áreas de la administración
pública estatal, dentro de sus facultades se encuentran:

<br></br><br></br>

<li>
Coordinación gubernamental: La Secretaría de Gobierno es responsable de la
coordinación entre las distintas áreas del gobierno estatal para asegurar la
implementación efectiva de políticas y programas gubernamentales. Además,
actúa como enlace con los municipios y otras entidades gubernamentales.</li>

<li>Regulación y supervisión de los órganos de gobierno: La Secretaría de
Gobierno tiene la facultad de supervisar y regular el funcionamiento de los
órganos de gobierno del estado, como las dependencias, entidades y
organismos descentralizados, para garantizar su correcto funcionamiento y
cumplimiento de sus atribuciones.</li>

<li>Relaciones institucionales y políticas: La Secretaría de Gobierno es la
encargada de establecer y mantener relaciones institucionales y políticas con
otros niveles de gobierno, organismos internacionales, organizaciones de la
sociedad civil y otros actores relevantes, con el objetivo de promover la
colaboración y coordinación en la implementación de políticas públicas.</li>

<li> Gestión de crisis y emergencias: La Secretaría de Gobierno tiene la
responsabilidad de coordinar y gestionar las acciones de respuesta y atención a
situaciones de crisis y emergencias en el estado, tales como desastres naturales,
conflictos sociales u otros eventos que requieran una rápida intervención
gubernamental.</li>

<li>Apoyo a la gobernabilidad: La Secretaría de Gobierno brinda apoyo técnico y
jurídico al Ejecutivo estatal en la toma de decisiones y en la implementación de
políticas públicas que contribuyan a la gobernabilidad del estado, incluyendo la
elaboración y seguimiento de normativas y reglamentos.</li></p>


              
<div className='secretaria-redes'>
    <a href='https://www.facebook.com/SegobHidalgoOficial' className="custom-button"><i class="fa-brands fa-facebook-f"></i></a>
    <a href='https://twitter.com/SEGOBHidalgo' className="custom-button"><i class="fa-brands fa-twitter"></i></a>
</div>

          </div>
        </div>
<br></br>



        <div className='row'>
          <div className='col-12'>
            <div className='notes_title'>
              <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='section_notes'>
              {
                titular.map((item, index) =>(
                    <>
                      <div key={ index } className='sec_photo'>
                        <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_container'>
                        <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                        </div>
                        <div className='sec_function'>
                          <h4>Función del Secretario</h4>
                          <p>{ item.funcion }</p>
                          <div className='btn_agenda'>
                            <Link to="Agenda">Conoce la agenda del Secretario</Link>

                           

                          </div>
                        </div>
                      </div>
                    </>
                ))
              }
            </div>
          </div>
        </div>
        <br></br><br></br>        <br></br><br></br>
 



        <br></br>
        <br></br>
        <br></br>




      <br></br><br></br>
      <Mosaico/>



        <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2649.007761463186!2d-98.73793275473524!3d20.123084976627787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a76107b036b3%3A0xd001bc38c9baafb5!2sPalacio%20del%20Gobierno%20del%20Estado%20de%20Hidalgo!5e0!3m2!1ses-419!2smx!4v1686085528870!5m2!1ses-419!2smx%22%20width=%22600%22%20height=%22450%22%20style=%22border:0;%22%20allowfullscreen=%22%22%20loading=%22lazy%22%20referrerpolicy=%22no-referrer-when-downgrade"
                      width="100%" 
                      height="300" 
                      frameborder="0" 
                      style={{border:0, marginBottom:50}} 
                      allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>   
      </div>
    </>
  )
}

export default Inicio